import React, { useContext } from 'react';
import useShiftService from '../../../app/services/hooks/useShiftService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    ShiftId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ShiftSwitchChange = ({ ShiftId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeShift, fetchingActiveShift } = useShiftService();

    const active = (value: boolean) => {
        setChecked(value);

        activeShift(ShiftId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={ShiftId} callback={active} />;
};

export default ShiftSwitchChange;
